import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Errors from './Errors';
import { replaceValueInEvent } from "@dnhb/node_package";

export const Container = styled('div')`
  position: relative;
  box-sizing: border-box;
  margin: ${({ margin }) => margin};
`;

const CheckboxTitle = styled('div')`
  position: relative;
  margin: 0 12px 0 0;

  box-sizing: border-box;
  min-width: 22px;
  width: 22px;
  height: 22px;
  border-radius: 5px;

  background-color: ${({ theme }) => theme.cardColor};
  border: 1px solid ${({ theme }) => theme.disabledBackgroundColor};
`;

const ContainerLabel = styled('label')`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
  
  &:hover ${CheckboxTitle} {
    box-shadow: 0 0 3px 1px ${props => props.theme.disabledBackgroundColor};
  }
`;

const Input = styled('input')`
  position: absolute;
  opacity: 0;

  &:checked {
    + ${CheckboxTitle} {
      background-color: ${({ theme }) => theme.primaryColor};
      border-color: ${({ theme }) => theme.primaryColor};

      &::after {
        position: absolute;
        box-sizing: border-box;
        top: 50%;
        left: 50%;

        width: 32.5%;
        height: 55%;
        content: '';

        border-right: 1.8px solid #fff;
        border-bottom: 1.8px solid #fff;
        transform: translate(-45%, -65%) rotate(45deg);

        //Mobile-calculation
        @media screen and (max-width: 1023px) {
          border-right: 2px solid #fff;
          border-bottom: 2px solid #fff;
        }
      }
    }
  }
  &:focus + ${CheckboxTitle} {
    box-shadow: 0 0 4px ${props => props.theme.primaryColor};
  }

`;

const Title = styled('span')`
  color: ${({ theme }) => theme.primaryFontColor};
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
`;

const Checkbox = ({ label, errors, margin, readOnly, value, onChange, children, ...props }) => (
  <Container margin={margin}>
    <ContainerLabel>
      <Input
        {...props}
        checked={value}
        readOnly={readOnly}
        type="checkbox"
        onChange={e => onChange(replaceValueInEvent(e, e.target.checked))}
      />
      <CheckboxTitle className="checkbox" readOnly={readOnly} errors={errors} />
      {children || (
        <Title className="checkbox"  errors={errors}>
          {label}
        </Title>
      )}
    </ContainerLabel>
    <Errors errors={errors} />
  </Container>
);

Checkbox.propTypes = {
  readOnly: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.node,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.bool,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  margin: PropTypes.string,
};

Checkbox.defaultProps = {
  readOnly: false,
  value: false,
  label: '',
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
  errors: null,
  margin: null,
};

export default Checkbox;
